import { createLucideIcon } from 'lucide-react';

// The glyph is a knockout in the disc, so it shows the surface behind the icon. A
// white disc below the coloured one fills the knockout with a fixed white. Its
// radius is 1 less, so no pale edge shows around the rim.

export const CircleCheckSolid = createLucideIcon('CircleCheckSolid', [
  [
    'circle',
    {
      cx: '12',
      cy: '12',
      r: '10',
      fill: '#fff',
      stroke: 'none',
    },
  ],
  [
    'path',
    {
      d: 'M12 23a11 11 0 1 0 0-22 11 11 0 0 0 0 22m5.5-13.8a1.18 1.18 0 1 0-1.84-1.47L10.1 14.7l-2.24-1.68a1.18 1.18 0 1 0-1.41 1.88l3.14 2.37c.5.37 1.23.29 1.63-.22z',
      fill: 'currentColor',
      fillRule: 'evenodd',
      stroke: 'none',
    },
  ],
]);
